"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExpensesModule = /** @class */ (function () {
    function ExpensesModule() {
    }
    return ExpensesModule;
}());
exports.ExpensesModule = ExpensesModule;
